import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import HyPETCanvas from "./CanvasComponent/HyPETCanvas";
import ClampUnitCanvas from "./CanvasComponent/ClampUnitCanvas";
import InjectionUnitCanvas from "./CanvasComponent/InjectionUnitCanvas";

const MachineCanvas = ({
  hoveredPart,
  setHoveredPart,
  selectedAsset,
  machineName,
  navigationState,
}: any) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Extract second-to-last segment from URL
  const segment =
    pathSegments.length >= 2
      ? decodeURIComponent(pathSegments[pathSegments.length - 2]).toLowerCase()
      : "";

  // Map for existing asset cases
  const partMap: Record<string, React.FC<any>> = {
    "transfer cylinder": InjectionUnitCanvas,
    "stationary platen": ClampUnitCanvas,
    mold: ClampUnitCanvas,
    "feed throat": InjectionUnitCanvas,
  };

  // Map for parent cases
  const machineMap: Record<string, React.FC<any>> = {
    hypet: HyPETCanvas,
    "clamp unit": ClampUnitCanvas,
    "injection unit": InjectionUnitCanvas,
    // mold: ClampUnitCanvas,
  };

  const renderCanvas = () => {
    // Check existing first
    const partKey = selectedAsset?.toLowerCase();
    if (partKey && partMap[partKey]) {
      const Component = partMap[partKey];
      return (
        <Component
          hoveredPart={hoveredPart}
          setHoveredPart={setHoveredPart}
          machineName={machineName}
          navigationState={navigationState}
        />
      );
    }

    // Otherwise, check parent
    const machineKey = Object.keys(machineMap).find((key) =>
      segment.includes(key)
    );

    if(machineKey && machineMap[machineKey]){
      const Component = machineMap[machineKey];
      return (
        <Component
          hoveredPart={hoveredPart}
          setHoveredPart={setHoveredPart}
          machineName={machineName}
          navigationState={navigationState}
        />
      );
    }
    return null;
  };

  return <Grid container>{renderCanvas()}</Grid>;
};

export default MachineCanvas;
